import { FeatureGroup } from "@kunduz/ui-components";
import React, { ReactElement } from "react";
import {
  MessageQuestionCircle,
  BookOpen01,
  PlayCircle,
  MessageChatCircle,
  MagicWand01,
  HeartHand,
} from "@untitled-ui/icons-react";
import { getCmsIcon } from "../iconMappings";

export const TrStudentWinningProps = (): ReactElement => {
  return (
    <FeatureGroup
      badgeText="KAZANDIRAN ÖZELLİKLER"
      features={[
        {
          icon: PlayCircle,
          title: "7.000+ Konu Anlatım Videosu",
          desc: "Zaman kazandıran ve müfredata uygun binlerce ders videosu ile konularını bitir.",
          detailLabel: "Detaylı Bilgi",
          link: "/tr/#konu_anlatim",
        },
        {
          icon: BookOpen01,
          title: "50.000+ Video Çözümlü Soru",
          desc: "Konuyu çalıştıktan sonra farklı yayınlardan 50 binin üzerinde video çözümlü soruyla konuyu pekiştir.",
          detailLabel: "Detaylı Bilgi",
          link: "/tr/#konu_anlatim",
        },
        {
          icon: MessageQuestionCircle,
          title: "7/24 Sınırsız Soru Çözüm",
          desc: "Çözemediğin soruları uzman eğitmenlere sor, 15 dakikada çözümü öğren.",
          detailLabel: "Detaylı Bilgi",
          link: "/tr/#soru_cozum",
        },
        {
          icon: MessageChatCircle,
          title: "Eğitmenlerle Sınırsız Birebir Görüşme",
          desc: "Çözemediğin soruları uzman eğitmenlere sor, 15 dakikada çözümü öğren.",
          detailLabel: "Detaylı Bilgi",
          link: "/tr/#birebir_gorusme",
        },
        {
          icon: MagicWand01,
          title: "Akıllı Seviye ve Eksik Tesbiti",
          desc: "Kunduz yapay zekasıyla seviyeni ve eksiklerini tanı, sana özgü çalışma önerileriyle netlerini artır.",
          detailLabel: "Detaylı Bilgi",
          link: "/tr/#birebir_gorusme",
        },
        {
          icon: HeartHand,
          title: "Grup Koçluk Seansları",
          desc: "Uzman rehberinden ve diğer öğrencilerden tüyoları al, motivasyonunu yüksek tut.",
          detailLabel: "Detaylı Bilgi",
          link: "/tr/#grup_kocluk",
        },
      ]}
      supportingText="Ders çalışırken neye ihtiyacın varsa; 7/24, dilediğin yerden ve sınırsız kullanabileceğin Kunduz özellikleriyle netlerini günden güne artır."
      title="Tüm ders çalışma adımlarını Kunduz'a sığdırdık!"
      badgeIcon={getCmsIcon("award-03")}
    />
  );
};
